// Generated by scripts/build-ui-icons.mjs.
export { FileDoc as default } from "../ui/glyphs-3";
